// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"238":"0b687902d94dd829","2260":"392744c6c0feea97","6673":"0c008fcfe3039448","9889":"84d172842457bfe1"}[chunkId] + ".css";
};